var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',_vm._g(_vm._b({attrs:{"href":_vm.href}},'a',_vm.$attrs,false),_vm.$listeners),[_vm._v(_vm._s(_vm.value))])
}
var staticRenderFns = []

export { render, staticRenderFns }